import pkg from '../package.json';

/** Company/organization name used in the app (login, header, etc.) */
export const COMPANY_NAME = 'Hebrew Academy for Special Children';

/** Original name used when the site was created (shown under current name) */
export const COMPANY_NAME_PREVIOUS = 'School Year Management System';

/** Application name (acronym) */
export const APP_NAME = 'SYMS';

/** Full application name */
export const APP_NAME_FULL = 'School Year Management System';

/** App version — sourced from package.json at build time */
export const APP_VERSION = pkg.version || '0.0.0';
